import axiosInstance from "../Utils/axiosConfig";

const getSupportedConversions = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/convert/GetSupportedConversions`
  );
  return response?.data;
};

const RequestQuoteGuest = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/convert/RequestQuoteGuest`,
    data
  );
  return response?.data;
};

const RequestQuote = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/convert/RequestQuote`,
    data,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    }
  );
  return response?.data;
};

const ExecuteQuote = async (quoteId) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/convert/ExecuteQuote/${quoteId}`,
    {},
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    }
  );
  return response?.data;
};

const ConvertHistory = async (params = {}) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/convert/ConversionHistory`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params,
    }
  );
  return response?.data;
};

const GetDustList = async (data) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/api/convert_exchange_token`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    }
  );
  return response?.data;
};

const ConvertDustToToken = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/api/convert_exchange_token`,
    data,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    }
  );
  return response?.data;
};

const convertService = {
  getSupportedConversions,
  RequestQuoteGuest,
  RequestQuote,
  ExecuteQuote,
  ConvertHistory,
  GetDustList,
  ConvertDustToToken,
};

export default convertService;
